import React, { useEffect, useState } from 'react';
import './ReportsSection.css';
import { Link } from 'react-router-dom';
import { Circles } from 'react-loader-spinner';
import publicAxios from '../../utils/axios/publicAxios';

const ReportsSection = () => {
  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState([]);

  const truncateTitle = (title, wordLimit = 15) => {
    const words = title.trim().split(/\s+/);
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(' ') + '...'
      : title;
  };

  useEffect(() => {
    const fetchReport = async () => {
      try {
        setLoading(true);
        const response = await publicAxios.get('/public/some-reports');
        setReports(response.data.reports || []);
      } catch (error) {
        console.error('Failed to fetch reports:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, []);

  if (loading) return <div style={{ display: 'flex', columnGap: '10px', alignItems: 'center', justifyContent: 'center', height: '500px', color: 'gray' }}>
    <Circles height="50" width="50" color="#008751" ariaLabel="loading" /> <h2>Loading Budget & Finance...</h2>
  </div>;

  return (
    <section className="reports-section">
      <div className="reports-section-wrapper">
        <Link to={'/reports'}><h2 className="reports-section-title">Planning, Budget & Development Reports</h2></Link>
        <div className="reports-section-grid">
          {reports.length === 0 ? (
            null
          ) : (
            reports.map((report) => (
              <Link to={`/report/${report.slug}`} key={report._id}>
                <div className="reports-section-card">
                  <h3>{truncateTitle(report.title)}</h3>
                </div>
              </Link>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default ReportsSection;